import { Output } from "valibot";

import { IntegrationOptionsSchema } from "components/SonicBot/schemas";
import { IntegrationType } from "shared/integrations/configs";

type Props = {
  integration: Output<typeof IntegrationOptionsSchema>;
  onIntegrationClick?: () => void;
  isLastMessage: boolean;
};

function IntegrationButton(props: Props) {
  const { integration, onIntegrationClick, isLastMessage } = props;
  if (!integration.name) {
    return null;
  }
  return (
    <div className="flex gap-2">
      <div className="inline-flex w-full flex-col items-start justify-start gap-3.5 rounded-xl border border-solid border-gray-200 p-4">
        {![IntegrationType.ZENDESK_LIVE_AGENT_HANDOFF].includes(
          integration.type,
        ) && (
          <div className="inline-flex items-center justify-start gap-2 self-stretch">
            <img className="h-6 w-6" src={integration.icon} />

            <span className="text-sm font-bold text-gray-900">
              {integration.title}
            </span>
          </div>
        )}

        <button
          onClick={onIntegrationClick}
          disabled={!isLastMessage}
          style={{
            borderRadius: "10px",
            padding: "8px",
            width: "100%",
            border: isLastMessage
              ? "1px solid var(--whiteOrChatBotColor)"
              : "1px solid gray",
            cursor: isLastMessage ? "pointer" : "not-allowed",
            color: "var(--invertedColor)",
            backgroundColor: isLastMessage ? "var(--chatBotColor)" : "gray",
          }}
        >
          {integration.name}
        </button>
      </div>
    </div>
  );
}

export default IntegrationButton;
